{
  "pricing": {
    "loadingInfo": "Caricamento informazioni sui prezzi...",
    "noPriceInfo": "Nessuna informazione sui prezzi disponibile",
    "takeGoldmakingNextLevel": "Porta il tuo goldmaking al livello successivo",
    "subscribeFrom": "Abbonati a soli {{price}} {{currency}} / mese. Nessun impegno. Annulla in qualsiasi momento.",
    "goldSubActive": "Il tuo abbonamento {{type}} attuale scade il {{expiration}}",
    "goldSubTitle": "Abbonamento Gold attivo",
    "goldSubUpgradeTitle": "Pronto a passare a Premium?",
    "goldSubHeading": "Bentornato, fabbricante d'oro",
    "goldSubHeadingSubtitle": "Grazie per essere un membro Gold — ecco il tuo abbonamento a colpo d'occhio.",
    "upgradeToPremiumContact": "Per passare al premium contatta il nostro staff su",
    "discordName": "Flipping Pal Discord",
    "manageBilling": "Gestisci fatturazione e metodi di pagamento",
    "manageBillingOpening": "Apertura...",
    "monthly": "Mensile",
    "yearly": "Annuale",
    "saveUpTo": "Risparmia fino al {{percent}}% con un abbonamento annuale.",
    "mostPopular": "Più popolare",
    "perMonth": "/mese",
    "perYear": "/anno",
    "startDate": "Data di inizio: {{date}}",
    "nextPaymentDate": "Prossima data di pagamento: {{date}}",
    "subscriptionEnds": "L'abbonamento termina: {{date}}",
    "reasonPaymentFailed": "Motivo: Pagamento non riuscito",
    "reasonCancelled": "Motivo: Annullato",
    "accessTools": "Accedi agli strumenti",
    "resumeSubscription": "Riprendi abbonamento",
    "cancelSubscription": "Annulla abbonamento",
    "processing": "Elaborazione...",
    "subscribeNow": "Abbonati ora",
    "getStarted": "Inizia",
    "switchToMonthly": "Passa a mensile",
    "switchToYearly": "Passa ad annuale",
    "upgradeToPremium": "Passa a Premium",
    "upgradeLabel": "Passa a Premium ({{billing}})",
    "downgradeToBasic": "Torna a Basic",
    "downgradeLabel": "Torna a Basic ({{billing}})",
    "switchPlan": "Cambia piano",
    "currentPlan": "Piano attuale",
    "statusActive": "Attivo",
    "statusExpired": "Scaduto",
    "statusCanceled": "Annullato",
    "statusInCancelation": "In annullamento",
    "showMoreFeatures": "+ {{count}} funzioni in più",
    "showFewerFeatures": "Mostra meno"
  },
  "trial": {
    "activatedTitle": "Prova attivata!",
    "activatedSubtitle": "Ecco cosa ottieni — e cosa ti aspetta",
    "startExploring": "Inizia a esplorare",
    "viewPlans": "Visualizza piani",
    "trialActive": "Prova gratuita attiva",
    "daysRemaining": "{{count}} giorno rimanente",
    "expires": "Scade il {{date}}",
    "trialLabel": "Prova",
    "compareButton": "Confronta piani",
    "trialEnded": "La tua prova gratuita è terminata. Abbonati per continuare a usare FlippingPal!",
    "haveTrialCode": "Hai un codice prova?",
    "trialCodeHint": "Usa",
    "trialCodeHint2": "nel nostro",
    "discordServer": "server Discord",
    "trialCodeHint3": "per ottenerne uno",
    "activateButton": "Attiva prova",
    "activatingButton": "Attivazione"
  },
  "features": {
    "basic": {
      "0": "Limitato a 10 regni di vendita",
      "1": "Strumento di housing per flippare e fare dropship di arredi",
      "2": "Strumento di flipping cross-realm",
      "3": "Strumento di dropship limitato a 3 risultati per oggetto",
      "4": "Statistiche del regno",
      "5": "Generatore di liste TSM",
      "6": "Fino a 50 snipe alert per Discord",
      "7": "Preset filtri limitati a 3",
      "8": "Supporto clienti dal team"
    },
    "premium": {
      "0": "Regni di vendita illimitati",
      "1": "Strumento di housing per flippare e fare dropship di arredi",
      "2": "Strumento di flipping cross-realm",
      "3": "Strumento di dropship aumentato a 10 risultati per oggetto",
      "4": "Statistiche del regno",
      "5": "Generatore di liste TSM",
      "6": "Strumento di analisi inventario",
      "7": "Fino a 9999 snipe alert per Discord",
      "8": "Preset filtri limitati a 50",
      "9": "Condivisione filtri con funzione di importazione/esportazione",
      "10": "Supporto clienti dal team",
      "11": "Supporto prioritario"
    }
  },
  "loading": "Caricamento informazioni sull'abbonamento..."
}
